import React from 'react';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { AssetAllocationChart } from '../../../AssetAllocationChart/AssetAllocationChart';

interface Props {
  tab: 'left' | 'right';
}

export const AssetAllocationCard = React.memo(({ tab }: Props) => {
  return (
    <Card display="flex" flexDirection="column">
      <AssetAllocationChart tab={tab} />
    </Card>
  );
});
